import React from "react"
import { useTranslation } from "react-i18next"

import type { Meter } from "@/models/meter"
import { AdminEntityLink } from "@/modules/admin/components/admin-entity-link"
import { adminEntityFieldsMaxWidthSx } from "@/modules/admin/utils/admin-entity-fields-max-width-sx"
import { ReadonlyField } from "@/nzds/forms/readonly-field/readonly-field"
import { useUrl } from "@/utils/url"
import { getDisplayValue } from "@/utils/value"

import { Stack } from "@mui/material"

import { MeterImmutableReadonlyFields } from "./meter-immutable-readonly-fields"

interface MeterReadonlyFieldsProps {
  meter: Meter
}

export const MeterReadonlyFields: React.FC<MeterReadonlyFieldsProps> = ({
  meter,
}) => {
  const { t } = useTranslation("common")
  const { adminSitePath } = useUrl()
  const siteId = meter.site?.id ?? null
  const rawSiteName = meter.site?.name
  const siteName = getDisplayValue(rawSiteName)
  const siteTo =
    siteId && rawSiteName?.trim() ? adminSitePath(siteId) : undefined

  return (
    <Stack sx={{ ...adminEntityFieldsMaxWidthSx, gap: 2 }}>
      <ReadonlyField
        label={t("fields.meterCode.title")}
        value={getDisplayValue(meter.meterCode)}
      />
      <ReadonlyField
        label={t("fields.siteName.title")}
        value={<AdminEntityLink label={siteName} to={siteTo} />}
      />
      <ReadonlyField
        label={t("fields.utilityProvider.title")}
        value={getDisplayValue(meter.meterProvider)}
      />
      <ReadonlyField
        label={t("editMeter.accountNumberLabel")}
        value={getDisplayValue(meter.accountNumber)}
      />
      <MeterImmutableReadonlyFields meter={meter} />
    </Stack>
  )
}
